import { Avatar, Box, Grid, Paper, Typography } from "@mui/material";
import React from "react";
import {
  flexBetweenCenter,
  itemsCenter,
  textEllipses,
} from "../../utilities/commonStyles/commonStyles";
import { useNavigate } from "react-router-dom";
import { StudentLeftArrowIcon } from "../../utilities/icons/icons";
import { styled } from "@mui/material/styles";

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: "#fff",
  padding: "15px",
  borderRadius: "10px",
}));

export default function StudentCard({ item }) {
  const navigate = useNavigate();

  return (
    <Box
      onClick={() => {
        navigate(item.id, {
          state: {
            userData: item,
          },
        });
      }}
      key={item.id}
      sx={{
        backgroundColor: "#fff",
        cursor: "pointer",
        p: "10px 10px",
        borderRadius: "7px",
        width: "340px",
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          // gap: "20px",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: "5px",
          }}
        >
          <Box>
            <Avatar
              src={item.image ?? ""}
              alt="studentImage"
              style={{
                width: "50px",
                height: "50px",
              }}
            />
          </Box>
          <Box sx={{ width: "80%" }}>
            <Typography
              sx={{
                width: "250px",
                mb: 0.5,
                fontWeight: 500,
                color: "#8CBE21",
                ...textEllipses,
              }}
            >
              {item?.name ?? ""}
            </Typography>
            <Typography
              sx={{
                fontSize: "12px",
                fontWeight: 500,
                color: "#959595",
              }}
            >
              ID: {item.id ?? 0}
            </Typography>
          </Box>
        </Box>
        <Box
          sx={{
            cursor: "pointer",
          }}
        >
          <StudentLeftArrowIcon />
        </Box>
      </Box>
    </Box>
  );
}
